"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANDADOC_METYCLE_DATE_FIELD_TAG = exports.PANDADOC_METYCLE_DATE_FIELD_ID = exports.PANDADOC_METYCLE_SIGNATURE_FIELD_TAG = exports.PANDADOC_METYCLE_SIGNATURE_FIELD_ID = exports.PANDADOC_OPERATIONS_CC_ROLE = exports.PANDADOC_METYCLE_SIGNER_ROLE = void 0;
exports.parseSignerFromRecipients = parseSignerFromRecipients;
exports.PANDADOC_METYCLE_SIGNER_ROLE = 'metycleSigner';
exports.PANDADOC_OPERATIONS_CC_ROLE = 'ccOps';
// Kept short deliberately: PandaDoc sizes the placed field to the tag text's
// rendered width, so every character in the tag widens the signature box.
exports.PANDADOC_METYCLE_SIGNATURE_FIELD_ID = 'mSig';
// PandaDoc's PDF-upload parser only recognizes curly-bracket field tags
// ({type:role:id___}); square-bracket notation is silently ignored, leaving
// the document with no signature field (verified empirically 2026-06-10
// against the PandaDoc API with one-tag-per-document uploads).
exports.PANDADOC_METYCLE_SIGNATURE_FIELD_TAG = `{s:${exports.PANDADOC_METYCLE_SIGNER_ROLE}:${exports.PANDADOC_METYCLE_SIGNATURE_FIELD_ID}______}`;
// Date stamped by the Metycle signer alongside the signature — legacy placed
// a 110pt-wide date field on the "Date, place, signature" line and Foundry
// matches it (legacy parity decision, see launchpad pandadoc-signing
// SIGNATURE_FIELD_LAYOUT).
exports.PANDADOC_METYCLE_DATE_FIELD_ID = 'mDate';
exports.PANDADOC_METYCLE_DATE_FIELD_TAG = `{d:${exports.PANDADOC_METYCLE_SIGNER_ROLE}:${exports.PANDADOC_METYCLE_DATE_FIELD_ID}__}`;
function asNonEmptyString(value) {
    return typeof value === 'string' && value.trim() !== '' ? value : null;
}
function parseObjectSigner(value) {
    const signer = value['signer'];
    if (signer === null || typeof signer !== 'object' || Array.isArray(signer))
        return null;
    const s = signer;
    return {
        email: asNonEmptyString(s['email']),
        first_name: asNonEmptyString(s['first_name']),
        last_name: asNonEmptyString(s['last_name']),
        is_fallback: s['is_fallback'] === true,
    };
}
function parseLegacyArraySigner(entries) {
    const recipients = entries.flatMap((entry) => {
        if (entry === null || typeof entry !== 'object' || Array.isArray(entry))
            return [];
        const e = entry;
        return [
            {
                email: asNonEmptyString(e['email']),
                first_name: asNonEmptyString(e['firstName']),
                last_name: asNonEmptyString(e['lastName']),
                is_cc: e['recipientType'] === 'CC',
            },
        ];
    });
    const signer = recipients.find((recipient) => !recipient.is_cc) ?? recipients[0];
    if (signer === undefined)
        return null;
    return {
        email: signer.email,
        first_name: signer.first_name,
        last_name: signer.last_name,
        is_fallback: false,
    };
}
/**
 * Resolves the primary signer out of a stored signing-recipients JSON value.
 *
 * Two shapes coexist in the column:
 *  - Foundry's signing flow writes an object `{ signer: {...}, cc: [...] }`
 *    whose signer carries snake_case fields (`first_name`, `last_name`,
 *    `is_fallback`).
 *  - Rows carried over from launchpad store the raw PandaDoc array
 *    `[{ email, recipientType, firstName, lastName }, ...]`; the signer is the
 *    first non-CC recipient, or the first entry when every recipient is CC.
 *
 * Returns `null` only when neither shape yields a recipient at all; an entry
 * with a missing or blank email still resolves so callers can fall back to the
 * recipient name.
 */
function parseSignerFromRecipients(value) {
    if (Array.isArray(value))
        return parseLegacyArraySigner(value);
    if (value !== null && typeof value === 'object') {
        return parseObjectSigner(value);
    }
    return null;
}
//# sourceMappingURL=pandadoc-signing.js.map